import React, { useEffect, useState } from "react";
import useShowAlert from "../../../utils/AlertUtiles";
import checkNetworkStatus from "../../common/networkStatus/CheckNetworkStatus";
import handleError from "../../../constant/handleError";
import { CircularProgress } from "@mui/material";
import axiosInstance from "../../../utils/AxiosInstance";
import { capitalizeFirstLetter } from "../../../utils/helper";
function AssignGangLeader({ onClose, loading,name, isSelectedData,setSelectedData, setLoading ,setBooking}) {
  const [isGLData, setGLData] = useState([]);
  const [selectedGL, setSelectedGL] = useState(null); 
  const [filteredGLData, setFilteredGLData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const showAlert = useShowAlert();
  const [isLoadingMore, setIsLoadingMore] = useState(false); 
  const [totalItem, setTotalItems] = useState(0);

  const handleGLData = async (loadMore = false) => {
    if (!isSelectedData?.pincode) {
            showAlert("error", "Booking Pincode not found. Cannot fetch relevant Captains.");
            return;
        }
    const perPage = 10;
    if (!loadMore) {
       setLoading((prev) => ({ ...prev, assignGLList: true }));
    } else {
      setIsLoadingMore(true);
    }
    checkNetworkStatus();
       const currentCount = filteredGLData.length;

    const limit = loadMore ? currentCount : perPage;
    const page = loadMore ? 2 : 1;
    try {
      const response = await axiosInstance.get(`gangleader/admin/pincode/list/${isSelectedData?.pincode}?pageno=${page}&limit=${limit}`);
//  const response =await axiosInstance.get(`http://localhost:3000/module/pincode`)
     if (response?.data?.status && response?.data?.results?.length > 0) {
  const newResults = response.data.results;

  if (loadMore) {
    // Append to old list
    setGLData(prev => [...prev, ...newResults]);
    setFilteredGLData(prev => [...prev, ...newResults]);
  } else {
    // First page load — replace
    setGLData(newResults);
    setFilteredGLData(newResults);
  }
}  
        setTotalItems(response.data.totalItems || 0);    
      
     
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, assignGLList: false }));
      setIsLoadingMore(false);
    }
  };

  const handleAssign = async () => {     
    setLoading((prev) => ({ ...prev, assignGLBtn: true }));
    checkNetworkStatus();
    try {
      const response = await axiosInstance.patch(
        `farmerbooking/admin/${isSelectedData._id}/assign/${selectedGL.partnerData.partnerId}`
       
      );
      showAlert( "success",response.data.message);
       setSelectedData((prevSelected) => ({
          ...prevSelected,
          // assignedTo: response.data.results.assignedTo,  
        assignedTo: {
          _id:selectedGL?._id,
          mobileNumber:selectedGL?.partnerData?.mobileNumber,
          isApproved:selectedGL?.partnerData?.isApproved,                 
          fullName:selectedGL?.partnerData?.fullName,
          capacityInAcres:selectedGL?.partnerData?.capacityInAcres,
        }, 
        }));
            setBooking((prevBookings) => {       
        return prevBookings.map((booking) => {        
          if (booking._id === isSelectedData._id) {           
            return {
              ...booking,
              assignedTo: {
          _id:selectedGL?._id,
          mobileNumber:selectedGL?.partnerData?.mobileNumber,
          isApproved:selectedGL?.partnerData?.isApproved,                 
          fullName:selectedGL?.partnerData?.fullName,
          capacityInAcres:selectedGL?.partnerData?.capacityInAcres,
        } 
            };
          }
          return booking; 
        });
      });
      onClose();
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setLoading((prev) => ({ ...prev, assignGLBtn: false }));
    }
  };

  useEffect(() => {
    handleGLData();
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);

    if (!value.trim()) {
      setFilteredGLData(isGLData);
      return;
    }

    const filtered = isGLData.filter((item) =>
      (item?.partnerData?.mobileNumber || "")
        .toString()
        .includes(value)
    );

    setFilteredGLData(filtered);
  };

    const handleLoadMore = () => {
    handleGLData(true);
  };
  return (
    <>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        id="ViewPartnerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content ">
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title fw-semibold">
                {name}:{" "}
                <span className="text-capitalize">
                  {isSelectedData?.pincode || isSelectedData?.bookingNumber || isSelectedData?.partnerId?.mobileNumber}
                </span>
              </h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
               <div>
                 <div className="input-group mb-2"><input type="text" class="form-control" maxLength={10} placeholder="Search by mobile number..." value={searchText}
                  onChange={(e) => {   
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  handleSearch(onlyNumbers);
                }}/>
              <button className="input-group-text"><i className="bx bx-search"></i></button></div>
            
               </div>
                   <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 font-12 ms-auto text-muted fw-bold">
                    Showing {filteredGLData.length} / {isGLData.length} 
                  </h6>
                </div>
              <div
                className={`${loading.assignGLList?"":"list-group border rounded-4"}`}             
              >
               {loading.assignGLList ? (
                <div className="text-center mt-3 ">
                  <CircularProgress size={22} className="text-green  round-0 border-none" />
                  </div>
              
              ) : isGLData.length === 0 ? (
                <p className="text-center py-3 mb-0">Pincode list data not found.</p>
              ) : (
                !loading.filteredGLData &&
                filteredGLData.map((gl) => (
                   <div
                  key={gl._id}
                  
                  className={`list-group-item d-flex justify-content-between align-items-start 
                    ${selectedGL?._id === gl._id ? "active" : ""}`}
                  onClick={() => {
                    setSearchText("");
                    setSelectedGL(gl);
                  }}
                  style={{ cursor: "pointer", padding: "12px" }}
                >
                  
                  <div className={selectedGL?._id === gl._id ? "text-success font-12" : "text-muted font-12"} style={{ flex: 1 }}>
                    
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <a href={`tel:+91${gl?.partnerData?.mobileNumber}`} className="text-black"><strong>{gl?.partnerData?.mobileNumber}</strong></a> 

                      {gl?.partnerData?.capacityInAcres && (
                        <strong>{gl.partnerData.capacityInAcres} acres</strong>
                      )}
                    </div>

                  
                    <div className="d-flex justify-content-between align-items-center w-100">
                    <p className="mb-0 mt-1">
                      Name: <strong>{capitalizeFirstLetter(gl?.partnerData?.fullName) || "-"}</strong>
                    </p>
                      {selectedGL?._id === gl._id && (
                    <i className="bx bx-check-circle fs-6  text-success ms-2"></i>
                  )}
                  </div>
                  </div>

                
                  {/* {selectedGL?._id === gl._id && (
                    <i className="bx bx-check-circle fs-4 text-success ms-2"></i>
                  )} */}
                </div>
                ))
              )}
              </div>
                {totalItem > 10 && filteredGLData.length < totalItem && (
                        <div className="text-center mt-3">
                          <button
                            onClick={handleLoadMore}
                            disabled={isLoadingMore}
                            className="btn btn-primary"
                          >
                            {isLoadingMore ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-3"></span>
                                Loading...
                              </>
                            ) : (
                              "Load More"
                            )}
                          </button>
                        </div>
                 )}
            </div>
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>
              {loading.assignGLBtn ? (
                <button className="btn btn-primary pb-0 text-right" disabled>
                  <CircularProgress size={22} className="text-white" />
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!selectedGL}
                  onClick={handleAssign}
                >
                  <i className="bx bx-check me-1"></i> Assign
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignGangLeader;